import Link from 'next/link'
import React from 'react'

function ShareWithSomeone({ careerDetails }) {
   return (
      <section className="section_secondary_bg summary-portfolio pt-0">
         <div className="container">
            <div className="dash-border"></div>
            <div className="job-action-buttons pt-5">
               <div className="d-flex align-items-center justify-content-center justify-content-md-between flex-wrap gap-4">
                  <Link
                     href="#apply-form"
                     className="btn bez-fill-btn job-action-buttons"
                  >
                     Apply for this job
                     <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M14.2011 19.6006C14.0025 19.6018 13.808 19.5437 13.6425 19.4339C13.477 19.3241 13.3479 19.1675 13.2718 18.9841C13.1956 18.8007 13.1758 18.5987 13.2148 18.4039C13.2539 18.2092 13.3501 18.0305 13.4911 17.8906L18.7911 12.6006L13.4911 7.31061C13.3273 7.11931 13.2417 6.87324 13.2514 6.62156C13.2611 6.36988 13.3655 6.13114 13.5436 5.95305C13.7217 5.77496 13.9604 5.67062 14.2121 5.6609C14.4638 5.65118 14.7098 5.73679 14.9011 5.90061L20.9011 11.9006C21.0874 12.088 21.1919 12.3414 21.1919 12.6056C21.1919 12.8698 21.0874 13.1233 20.9011 13.3106L14.9011 19.3106C14.7149 19.4954 14.4635 19.5995 14.2011 19.6006Z"
                           fill="#F4F2F0"
                        />
                        <path
                           d="M6.19527 19.6017C5.99664 19.6029 5.80218 19.5449 5.63666 19.4351C5.47114 19.3253 5.34206 19.1687 5.2659 18.9852C5.18973 18.8018 5.16992 18.5998 5.20899 18.4051C5.24806 18.2103 5.34424 18.0316 5.48527 17.8918L10.7853 12.6017L5.48527 7.31175C5.29697 7.12344 5.19118 6.86805 5.19118 6.60175C5.19118 6.33545 5.29697 6.08005 5.48527 5.89175C5.67357 5.70344 5.92897 5.59766 6.19527 5.59766C6.46157 5.59766 6.71697 5.70344 6.90527 5.89175L12.9053 11.8917C13.0915 12.0791 13.1961 12.3326 13.1961 12.5967C13.1961 12.8609 13.0915 13.1144 12.9053 13.3017L6.90527 19.3018C6.81265 19.3962 6.70221 19.4714 6.58033 19.5229C6.45846 19.5744 6.32758 19.6012 6.19527 19.6017Z"
                           fill="#F4F2F0"
                        />
                     </svg>
                  </Link>
                  <div className="share-section">
                     <p className="share-text mb-2">
                        Share With Someone Awesome
                     </p>
                     <div className="social-icons justify-content-center d-flex gap-3">
                        <a
                           target="_blank"
                           href={`http://www.linkedin.com/shareArticle?mini=true&url=${process.env.NEXT_PUBLIC_DOMAIN_NAME}/discover-benzatine/career-overview/${careerDetails?.slug}/&title=${careerDetails?.title}`}
                           className="social-link"
                           id="linkedin-link"
                        >
                           <svg
                              width="28"
                              height="29"
                              viewBox="0 0 28 29"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <g clipPath="url(#clip0_5451_25445)">
                                 <path
                                    d="M6.25 28.1907H0.438V9.50366H6.25V28.1907ZM3.313 7.00366C1.5 7.00366 0 5.44066 0 3.56566C0 1.75366 1.5 0.253662 3.313 0.253662C5.187 0.253662 6.688 1.75366 6.688 3.56566C6.688 5.44066 5.188 7.00366 3.313 7.00366ZM27.938 28.1907H22.188V19.1287C22.188 16.9407 22.125 14.1907 19.125 14.1907C16.125 14.1907 15.688 16.5037 15.688 18.9407V28.1907H9.875V9.50366H15.438V12.0657H15.5C16.313 10.6287 18.188 9.06566 21 9.06566C26.875 9.06566 28 12.9407 28 17.9407V28.1907H27.938Z"
                                    fill="#88998D"
                                 />
                              </g>
                              <defs>
                                 <clippath id="clip0_5451_25445">
                                    <rect
                                       width="28"
                                       height="28"
                                       fill="white"
                                       transform="translate(0 0.190674)"
                                    />
                                 </clippath>
                              </defs>
                           </svg>
                        </a>
                        <a
                           target="_blank"
                           className="social-link"
                           href={`https://www.facebook.com/sharer/sharer.php?u=${process.env.NEXT_PUBLIC_DOMAIN_NAME}/discover-benzatine/career-overview/${careerDetails?.slug}/&amp;title=${careerDetails?.title}`}
                           id="fb-link"
                        >
                           <svg
                              width="28"
                              height="29"
                              viewBox="0 0 28 29"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <g clipPath="url(#clip0_5451_25453)">
                                 <mask
                                    id="mask0_5451_25453"
                                    style={{ maskType: 'luminance' }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="28"
                                    height="29"
                                 >
                                    <path
                                       d="M0 0.190674H28V28.1907H0V0.190674Z"
                                       fill="white"
                                    />
                                 </mask>
                                 <g mask="url(#mask0_5451_25453)">
                                    <path
                                       d="M28 14.1907C28 6.45867 21.732 0.190674 14 0.190674C6.268 0.190674 0 6.45867 0 14.1907C0 20.7567 4.52 26.2657 10.618 27.7787V18.4687H7.731V14.1907H10.618V12.3467C10.618 7.58167 12.774 5.37367 17.453 5.37367C18.34 5.37367 19.87 5.54767 20.496 5.72167V9.59967C20.166 9.56467 19.592 9.54767 18.879 9.54767C16.583 9.54767 15.696 10.4177 15.696 12.6777V14.1907H20.269L19.483 18.4687H15.696V28.0887C22.628 27.2507 28 21.3477 28 14.1907Z"
                                       fill="#88998D"
                                    />
                                    <path
                                       d="M19.4835 18.4707L20.2695 14.1907H15.6965V12.6777C15.6965 10.4167 16.5835 9.54766 18.8785 9.54766C19.5915 9.54766 20.1655 9.56466 20.4955 9.59966V5.72066C19.8695 5.54666 18.3395 5.37366 17.4525 5.37366C12.7745 5.37366 10.6175 7.58166 10.6175 12.3467V14.1907H7.73047V18.4687H10.6175V27.7787C12.2773 28.1914 13.9987 28.2964 15.6965 28.0887V18.4687L19.4835 18.4707Z"
                                       fill="#F1ECDC"
                                    />
                                 </g>
                              </g>
                              <defs>
                                 <clippath id="clip0_5451_25453">
                                    <rect
                                       width="28"
                                       height="28"
                                       fill="white"
                                       transform="translate(0 0.190674)"
                                    />
                                 </clippath>
                              </defs>
                           </svg>
                        </a>
                        <a
                           target="_blank"
                           className="social-link"
                           href={`https://twitter.com/intent/tweet?url=${process.env.NEXT_PUBLIC_DOMAIN_NAME}/discover-benzatine/career-overview/${careerDetails?.slug}&amp;text=${careerDetails?.title}`}
                           id="x-link"
                        >
                           <svg
                              width="25"
                              height="26"
                              viewBox="0 0 25 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <g clipPath="url(#clip0_5451_25447)">
                                 <mask
                                    id="mask0_5451_25447"
                                    style={{ maskType: 'luminance' }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="25"
                                    height="26"
                                 >
                                    <path
                                       d="M0 0.690674H25V25.6907H0V0.690674Z"
                                       fill="white"
                                    />
                                 </mask>
                                 <g mask="url(#mask0_5451_25447)">
                                    <path
                                       d="M14.8275 11.2767L23.9345 0.690674H21.7765L13.8685 9.88267L7.55353 0.690674H0.269531L9.81953 14.5907L0.269531 25.6907H2.42753L10.7775 15.9847L17.4475 25.6907H24.7315L14.8275 11.2767ZM11.8715 14.7127L10.9035 13.3287L3.20453 2.31567H6.52053L12.7335 11.2027L13.7015 12.5867L21.7785 24.1397H18.4635L11.8715 14.7127Z"
                                       fill="#88998D"
                                    />
                                 </g>
                              </g>
                              <defs>
                                 <clippath id="clip0_5451_25447">
                                    <rect
                                       width="25"
                                       height="25"
                                       fill="white"
                                       transform="translate(0 0.690674)"
                                    />
                                 </clippath>
                              </defs>
                           </svg>
                        </a>
                     </div>
                  </div>

                  <Link
                     href="/discover-benzatine/career-overview#job-list"
                     className="btn btn-primary info_tell_btn"
                  >
                     VIEW ALL JOB OPENINGS
                     <svg
                        width="17"
                        height="15"
                        viewBox="0 0 17 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M9.50582 14.1907C9.30719 14.1919 9.11272 14.1338 8.9472 14.024C8.78168 13.9142 8.65261 13.7576 8.57644 13.5742C8.50028 13.3907 8.48047 13.1888 8.51954 12.994C8.55861 12.7993 8.65479 12.6206 8.79582 12.4807L14.0958 7.1907L8.79582 1.9007C8.63199 1.7094 8.54638 1.46332 8.5561 1.21165C8.56583 0.959972 8.67016 0.721232 8.84825 0.543138C9.02635 0.365043 9.26509 0.260711 9.51676 0.25099C9.76844 0.241269 10.0145 0.326875 10.2058 0.490701L16.2058 6.4907C16.3921 6.67806 16.4966 6.93152 16.4966 7.1957C16.4966 7.45989 16.3921 7.71334 16.2058 7.9007L10.2058 13.9007C10.0196 14.0854 9.76816 14.1896 9.50582 14.1907Z"
                           fill="#1F473E"
                        />
                        <path
                           d="M1.49996 14.1906C1.30133 14.1918 1.10686 14.1337 0.941343 14.0239C0.775823 13.9141 0.646752 13.7575 0.570586 13.5741C0.494419 13.3907 0.474607 13.1887 0.513677 12.9939C0.552747 12.7992 0.648927 12.6205 0.789956 12.4806L6.08996 7.19062L0.789956 1.90062C0.601653 1.71231 0.495865 1.45692 0.495865 1.19062C0.495865 0.924314 0.601653 0.668919 0.789956 0.480615C0.97826 0.292311 1.23365 0.186523 1.49996 0.186523C1.76626 0.186523 2.02165 0.292311 2.20996 0.480615L8.20996 6.48062C8.39621 6.66798 8.50075 6.92143 8.50075 7.18562C8.50075 7.4498 8.39621 7.70325 8.20996 7.89062L2.20996 13.8906C2.11734 13.9851 2.0069 14.0603 1.88502 14.1118C1.76315 14.1633 1.63226 14.1901 1.49996 14.1906Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </Link>
               </div>
            </div>
         </div>
      </section>
   )
}

export default ShareWithSomeone
